angular.module('cian.dealTypeBrowser')
.directive('dealTypeBrowser', function () {
  return {
    scope: {},
    template: require('../../templates/deal-type-browser.html'),
    restrict: 'E',
    controller: ['FilterService', function (FilterService) {
      this.options = [{
        text: 'Купить',
        value: { type: 'sale' },
      }, {
        text: 'Снять',
        value: { type: 'rent', shortTerm: false },
      }, {
        text: 'Посуточно',
        value: { type: 'rent', shortTerm: true },
      }];

      // Initial value
      this.selectedOption = this.options.find(t => {
        if (FilterService.dealTypeIs('sale')) {
          return t.value.type === 'sale';
        } else {
          return t.value.type === 'rent' && t.value.shortTerm === FilterService.isShortTerm();
        }
      }).value;

      this.changeType = () => {
        FilterService.setDealType(this.selectedOption.type, this.selectedOption.shortTerm);
      };
    }],
    controllerAs: 'dealType',
  };
});



// WEBPACK FOOTER //
// ./src/components/deal-type-browser/src/scripts/cian.deal-type-browser.dir.js